exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-boxed{width:calc(100% - 48px);max-width:1200px;overflow-x:hidden;margin:0 auto;padding-bottom:65px}@media(max-width: 640px){.c-boxed{width:calc(100% - 32px)}}", ""]);

// exports
